import tooltipDirective from "./Tooltip/";

// register all directives
const directives = (app) => {
  tooltipDirective(app);
};

export default directives;